import React, { useState, useEffect } from 'react'
import measurementTypes from '../../_constants/measurementTypes'
import ConvertQuantity from './ConvertQuantity'

const MeasurementTypeDoubleBox = props => {

  const [product, setProduct] = useState(props.product)
  const [type, setType] = useState(props.type)
  const [value, setValue] = useState(props.value)

  const [sign, setSign] = useState(props.sign)
  const [onlySub, setOnlySub] = useState(props.onlySub)

  const [finalValue, setFinalValue] = useState(0)
  const [finalLabel, setFinalLabel] = useState('')

  const [finalSubValue, setFinalSubValue] = useState(0)
  const [finalSubLabel, setFinalSubLabel] = useState('')

  useEffect(() => {

    const { measurementType, subMeasurementType, conversionUnit } = product;


    setFinalValue(Number(value.toFixed(3)))

    setFinalLabel(measurementType != undefined && measurementTypes.filter(el => el.value === measurementType)[0] ? measurementTypes.filter(el => el.value === measurementType)[0].label : '')


    setFinalSubValue(conversionUnit ? ConvertQuantity(value, conversionUnit, 3, 2) : undefined)

    setFinalSubLabel(subMeasurementType != undefined ? measurementTypes.filter(el => el.value === subMeasurementType)[0].label : '');


  }, [])


  return (
    <React.Fragment>
      <div className="MeasurementTypeDoubleBox">
        {!onlySub ?
          <div className={finalSubValue ? "value-box" : "value-box single"}>
            <span className="mtb-value">{sign !== undefined ? <>{sign + ' '}</> : ''}{finalValue}</span>
            <span className="mtb-label">{finalLabel}</span>
          </div>
          : ''}
        {finalSubValue ?
          <div className={onlySub ? "value-box sub only-sub" : "value-box sub"}>
            <span className="mtb-value">{sign !== undefined ? <>{sign + ' '}</> : ''}{finalSubValue}</span>
            <span className="mtb-label">{finalSubLabel}</span>
          </div>
          : ''}
      </div>
    </React.Fragment>
  )
}

export default MeasurementTypeDoubleBox;